<template lang="pug">
#timesheet.vue-time-entries-daily.time-entries-wrapper
  TimeEntriesForDate(
    v-for="group in timeEntriesByDate"
    :key="formatDate(group.date)"
    :date="group.date"
    :time-entries="group.entries"
    :show-timeline="showTimeline"
    :show-empty="showEmpty"
    :reasons-or-notes-are-present="reasonsOrNotesArePresent"
    @show-notes-dialog="showNotesDialog"
  )
  TimeEntriesNotesDialog(
    :show="showTimeEntriesNotesDialog"
    :time-entries="timeEntriesForNotesDialog"
    :date="dateForNotesDialog"
    @close="closeTimeEntriesNotesDialog"
  )
</template>
<script>
import { mapGetters } from 'vuex';
import { map, keys, xor, groupBy, orderBy, forEach } from 'lodash-es';
import { createWithZone } from '~/utils/time_utils';

export default {
  name: 'TimeEntriesDaily',
  props: {
    timeEntries: Array,
    dateEnd: String,
    date: String,
    order: {
      type: String,
      default: 'desc',
    },
    showTimeline: {
      type: Boolean,
      default: true,
    },
    showEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showTimeEntriesNotesDialog: false,
      timeEntriesForNotesDialog: [],
      dateForNotesDialog: moment(),
    };
  },
  computed: {
    ...mapGetters(['currentZone', 'reasonsOrNotesArePresent', 'isTimesheetPage']),
    timeEntriesByDate() {
      const dates = this.allDatesInRange;
      const filteredEntries = this.timeEntries.filter((entry) => dates.includes(this.formatDate(entry.start_time)));
      let grouped;

      if (this.isTimesheetPage) {
        grouped = groupBy(this.timeEntries, (te) => this.formatDate(te.start_time));
      } else {
        grouped = groupBy(filteredEntries, (te) => this.formatDate(te.start_time));
        this.addMissingDates(grouped);
      }

      const groupedWithDate = map(grouped, (dateGroup, date) => ({
        entries: dateGroup,
        date: createWithZone(date, null, this.currentZone.name),
      }));
      const sorted = orderBy(groupedWithDate, ['date'], [this.order]);

      return sorted;
    },
    allDatesInRange() {
      const endDate = createWithZone(this.dateEnd, null, this.currentZone.name).startOf('day');
      const startDate = createWithZone(this.date, null, this.currentZone.name).startOf('day');
      const dates = [this.formatDate(startDate)];

      while (startDate.add(1, 'days').diff(endDate) <= 0) {
        const formattedDate = this.formatDate(startDate);

        dates.push(formattedDate);
      }

      return dates;
    },
  },
  methods: {
    formatDate(date) {
      return date.format('YYYY-MM-DD');
    },
    addMissingDates(grouped) {
      const datesWithEntries = keys(grouped);
      const missingDates = xor(this.allDatesInRange, datesWithEntries);

      forEach(missingDates, (date) => {
        grouped[date] = [];
      });
    },
    showNotesDialog(data) {
      const $window = $(window);

      if ($window.width() < 768) {
        $window.scrollTop(0);
      }
      this.showTimeEntriesNotesDialog = true;
      this.dateForNotesDialog = data.date;
      this.timeEntriesForNotesDialog = data.timeEntries;
    },
    closeTimeEntriesNotesDialog() {
      this.showTimeEntriesNotesDialog = false;
    },
  },
};
</script>
